import moment from 'moment';
import React from 'react';
import { t } from '../multi-language/multi-lang.service';
function RtRecordingTime(_a) {
    var record = _a.record;
    return (React.createElement("div", { className: 'rt-recording' },
        React.createElement("span", { className: '' },
            t('charts.recording.summary'),
            ":  ",
            moment(record.start).format('HH:mm'),
            " - ",
            moment(record.end).format('HH:mm, MMM DD, YYYY')),
        React.createElement("span", { className: 'ms-5' },
            t('charts.recording.total'),
            ": ",
            Math.floor(record.total / 60),
            " ",
            t('general_words.minutes'),
            " ",
            record.total % 60,
            " ",
            t('general_words.seconds'))));
}
export default RtRecordingTime;
//# sourceMappingURL=rt-recording-time.js.map